export { default } from './SkeletonFareTable';
